import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isGranted('DELETE_SOCIAL_ACCOUNT'))
    ? (_openBlock(), _createBlock(_component_q_btn, {
        key: 0,
        icon: "fa fa-times",
        label: "Delete Social Account",
        color: "red-1",
        "text-color": "dark",
        unelevated: "",
        rounded: "",
        "no-caps": "",
        onClick: _ctx.openModal
      }, null, 8, ["onClick"]))
    : _createCommentVNode("", true)
}